import React, { Suspense, lazy } from 'react';

const StoryPopup = lazy(() => import('./storyPopup'));

interface StoriesPopupLazyProps {
    sourceRoute: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const StoriesPopupLazy = ({ sourceRoute }: StoriesPopupLazyProps) => {
    return (
        <Suspense fallback={<div>loading...</div>}>
            <StoryPopup sourceRoute={sourceRoute}  />
        </Suspense>
    );
};